import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const setAuth = useAuthStore(state => state.setAuth);

  useEffect(() => {
    const token = params.get('token');
    const userStr = params.get('user');
    const error = params.get('error');

    if (error) {
      navigate(`/login?error=${encodeURIComponent(error)}`);
      return;
    }

    if (token && userStr) {
      try {
        const user = JSON.parse(decodeURIComponent(userStr));
        setAuth(token, user);
        // Resume an OAuth consent flow that sent us through Google sign-in.
        const oauthReturn = sessionStorage.getItem('mc_oauth_return');
        if (oauthReturn) {
          sessionStorage.removeItem('mc_oauth_return');
          navigate(oauthReturn);
          return;
        }
        // Finish an invite that sent us through Google sign-in. A new account
        // had it applied by the server already; the invite page recognises the
        // spent link and moves on.
        const pendingInvite = sessionStorage.getItem('mc_invite_return');
        if (pendingInvite) {
          sessionStorage.removeItem('mc_invite_return');
          navigate(`/invite/${encodeURIComponent(pendingInvite)}?after=signin`);
          return;
        }
        const isNew = params.get('new') === '1';
        navigate(isNew ? '/billing?welcome=1' : '/');
      } catch {
        navigate('/login?error=Invalid+response+from+server');
      }
    } else {
      navigate('/login');
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
      <div className="text-gray-400 text-sm">Signing in...</div>
    </div>
  );
}
